export default {
  methods: {

    set_LocalValues(){
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      // Scroll Pre-Proceassing
      this.scroll = {
        bar: {
          y: 0,
          size:     null,
          ratio:    null,
          space:    null,
          padding:  json.scroll.padding,
          width:    json.scroll.width,
          color:    json.scroll.color,
          opacity:  json.scroll.opacity,
        },
        viewbox: {
          height: json.scroll.viewbox_Height,
          space: null,
        },
        content: {
          y: 0,
          height: null,
        },
        wheel: {
          count: 0,
          step: null,
          ratio: null,
        },
      }
      // this.set_ScrollValues()
      

      // JQueries
      this.title   = json.title
      this.radio   = json.radio
      this.header  = json.header
      this.groups  = json.groups
      this.values  = json.values
      this.sundries  = json.sundries
      this.keys    = json.keys
      this.filters = json.filters

      this.current = this.radio.list[0] // set Current

      // ------------------------------------------------ for Exporting PDF file
      this.getItems = this.getSelectItems ? JSON.parse(this.getSelectItems) : {}
      if (this.getItems.current) {
        this.current = this.getItems.current
      } // ---------------------------------------------------------------------

      this.tDisplay = (this.groups.subTotal.visible == 'Y') ? true : false

      // Set Coordinate of Group Columns
      this.groups.width = this.gmx_tableCoordinates('x', this.groups.columns, this.values.cellPadding)

      // Set Coordinate of Data Columns
      this.values.width = this.gmx_tableCoordinates('x', this.values.columns, this.values.cellPadding)

      // Set Header's Coordinate for Column and Depth - sx, mx, ex, sy, my, ey
      this.header.columns = []
      this.groups.columns.forEach(d=> { this.header.columns.push({type: 'group', code: d.code, width: d.width, stroke: d.stroke}) })
      this.values.columns.forEach(d=> { this.header.columns.push({type: 'value', code: d.code, width: d.width, stroke: d.stroke}) })

      this.header.width = this.gmx_tableCoordinates('x', this.header.columns, 0)
      this.header.height = this.gmx_tableCoordinates('y', this.header.depths, 0)
    },


    set_filterData() {
      this.nativeData = (this.radio.visible == 'Y') ? this.rawData.filter(f=> f[this.radio.refCode] == this.current.value) : this.rawData
      this.dataSet = JSON.parse(JSON.stringify(this.nativeData))

      this.tableHeight = this.values.lineHeight * this.dataSet.length
    },


    set_HeaderValue() {
      let depths = this.header.depths
      let cols = this.header.columns
      let titles = this.header.titles
      let newHeaders = []

      // Set ColSpan
      titles.forEach((row,r)=>{
        newHeaders.push([])
        row.forEach((col,c)=> {
          let count = 1
          for(let i=c+1; i<row.length; i++) { if(row[i] == '-') count = count + 1; else break }
          newHeaders[r].push({name: col, colspan: count})
        })
      })
      // console.log(newHeaders)
      newHeaders = newHeaders[0].map((_, m)=> newHeaders.map(rows => rows[m]))
      
      // Set RowSpan
      newHeaders.forEach((row,r)=> {
        row.forEach((col,c)=> {
          if(col.name !== '+') {
            let count = 1
            for(let i=c+1; i<row.length; i++) { if(row[i].name == '+') count = count + 1; else break }
            newHeaders[r][c].rowspan = count
          } 
        })
      })
      newHeaders = newHeaders[0].map((_, m)=> newHeaders.map(rows => rows[m]))

      // Set Style
      newHeaders.forEach((row,r)=> {
        row.forEach((col,c)=> {
          if(col.name == '-' || col.name == '+') return
          col.sx = cols[c].sx
          col.ex = cols[c + (col.colspan-1)].ex
          col.mx = col.sx + (col.ex - col.sx)/2
          col.sy = depths[r].sy
          col.ey = depths[r + (col.rowspan-1)].ey
          col.my = col.sy + (col.ey - col.sy)/2
          // Style
          col.tSize  = depths[r].tSize
          col.tColor = depths[r].tColor
          col.hStroke = depths[r].stroke
          col.bColor = depths[r].bColor || null
          col.opacity = depths[r].opacity || 1
          col.vStroke = this.header.columns[c].stroke
        })
      })
      // console.log(newHeaders)
      this.draw_Header(newHeaders)
    },


    set_GroupValues () {
      let columns = this.groups.columns

      // Data preprocessing for Grouping & Total 
      this.nativeData.forEach((d,i)=> {
        let compare = true
        let stroke = {x: 0, first: 0, h: columns[columns.length-1].stroke}
        let overall = {cnt:0, from:0, to: 0}

        if(i > 0) {
          columns.forEach((c,j)=> {
            if(compare && d[c.code] == this.nativeData[i-1][c.code]) {
              this.dataSet[i][c.code] = null
              stroke.x = c.ex
            } else {
              compare = false
              if(stroke.first==0) stroke.h = c.stroke
              stroke.first = stroke.first + 1
            }

            if(d[c.code] == 'OVERALL') {
              if(overall.cnt==0) overall.from = j
              overall.cnt = overall.cnt + 1
              if(overall.cnt>0) overall.to = j
            }
            if(c.tColor == undefined || c.tColor == '') c.tColor = this.groups.defaultColor
          })
        }
        this.dataSet[i].mgx = stroke.x
        this.dataSet[i].hStroke = stroke.h
        this.dataSet[i].overallCount = overall.cnt
        this.dataSet[i].overall = (overall.cnt > 0) ? true : false
        this.dataSet[i].ttx = columns[overall.from].sx + (columns[overall.to].ex - columns[overall.from].sx) / 2
      })
      this.groups.overallCount = this.dataSet.filter(f=> f.overall).length
      this.draw_dataGroups() // -----> draw_TableGroup.js
    },


    set_DataColumns() {
      this.values.columns.forEach(d=> {
        if(d.tColor == undefined || d.tColor == '') d.tColor = this.values.defaultColor
      })

      this.draw_dataValues() // -----> draw_TableData.js
    },


    set_ScrollValues() {

      this.scroll.bar.size = this.scroll.viewbox.height / this.scroll.content.height * this.scroll.viewbox.height

      this.scroll.viewbox.space = this.scroll.content.height - this.scroll.viewbox.height + 1
      this.scroll.wheel.step = parseInt(this.scroll.viewbox.space/30)
      this.scroll.wheel.ratio = 1 / this.scroll.wheel.step
      
      this.scroll.bar.space = this.scroll.viewbox.height - this.scroll.bar.size
      this.scroll.bar.ratio = this.scroll.bar.space / this.scroll.wheel.step
    }
  }
}